import { ReportData } from '../types/reportTypes';

// Cody Cline Direct Sales June 2026 Data (15 jobs)
// IMPORTANT: Using 13% flat OH calculation (Contract Total × 0.13) per CLAUDE.md
// Source CSV: sample csv/2025 TLLG Marketing Leads Report - Cody - Sales Jun26.csv
// Verified aggregates (sum-of-rows vs CSV Totals row):
//   CT $313,491.61 (matches)
//   GP $139,551.55 (CSV Totals $139,551.53, +$0.02 sub-cent drift - sum-of-rows used)
//   GP margin 44.52%
//   OH (13% flat, per-job): $40,753.91
//   Net (GP - OH): $98,797.64 (31.52%)
//   Commission (sum of per-job Net ÷ 2): $49,398.82
// CSV header "Net Profit $80,107.85 / 25.55%" IGNORED — computed against 15.5% Standard OH
// column ($48,591.23), not 13% Cody flat per CLAUDE.md retroactive to 1/1/2025.
// Trade name normalization:
//   - E-1109 "Painting & Others, ROI Roofing" -> Painting & Others (first trade)
//   - E-1137 "Painting & Others, ROI Flooring, ROI Gutters" -> Painting & Others (first trade)
//   - "Miscellaneous" (E-1123) preserved verbatim
//   - "Solar" (S-3679) preserved verbatim
const jobData = [
  { jobInfo: "E-1094: RAMIN ABRAHIM", leadSource: "Referral- Cody's network", trade: "Roofing", contractTotal: 21936.00, grossMarginPct: 0.4779, grossProfit: 10483.21, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 21936.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1116: Thrifty Iron  Works", leadSource: "Referral- Cody's network", trade: "Roofing", contractTotal: 2890.00, grossMarginPct: 0.3000, grossProfit: 867.00, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 2890.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1127: Kingsgate A Condominium", leadSource: "Referral- Cody's network", trade: "Windows & Doors", contractTotal: 1835.00, grossMarginPct: 0.4094, grossProfit: 751.25, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 1835.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1128: Aion Management The Ridge", leadSource: "Referral- Cody's network", trade: "Siding", contractTotal: 3800.00, grossMarginPct: 0.4844, grossProfit: 1840.72, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 3800.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1095: Jeramie Killingsworth", leadSource: "Referral- Dominic's network", trade: "Roofing", contractTotal: 5975.00, grossMarginPct: 0.3738, grossProfit: 2233.46, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 5975.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1124: Solution Based Property Management", leadSource: "Referral- Cody's network", trade: "Roofing", contractTotal: 432.00, grossMarginPct: 0.3000, grossProfit: 129.60, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 432.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1122: Pat Chirichella", leadSource: "Referral- Cody's network", trade: "Gutters", contractTotal: 800.00, grossMarginPct: 0.4344, grossProfit: 347.52, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 800.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1109: Pennrose Management Oak Liberty Property", leadSource: "Referral- Cody's network", trade: "Painting & Others", contractTotal: 1985.00, grossMarginPct: 0.5970, grossProfit: 1185.05, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 1985.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1129: Tidewater Properties Copper Hill", leadSource: "Referral- Cody's network", trade: "Roofing", contractTotal: 7490.00, grossMarginPct: 0.3811, grossProfit: 2854.44, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 7490.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1130: Tidewater Properties Copper Hill", leadSource: "Referral- Cody's network", trade: "Roofing", contractTotal: 8115.00, grossMarginPct: 0.3677, grossProfit: 2983.89, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 8115.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1137: Judy  Tran", leadSource: "Referral- Dominic's network", trade: "Painting & Others", contractTotal: 146825.61, grossMarginPct: 0.3000, grossProfit: 44047.68, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 146825.61 * 0.13, netProfit: 0 },
  { jobInfo: "E-1123: Ellicott Hills Condo 1", leadSource: "Referral- Dominic's network", trade: "Miscellaneous", contractTotal: 1645.00, grossMarginPct: 0.3739, grossProfit: 615.07, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 1645.00 * 0.13, netProfit: 0 },
  { jobInfo: "E-1082: Anne Fraser", leadSource: "Referral- Dominic's network", trade: "Siding", contractTotal: 64437.80, grossMarginPct: 0.9409, grossProfit: 60629.53, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 64437.80 * 0.13, netProfit: 0 },
  { jobInfo: "E-1025: Casey  Maker", leadSource: "Referral- Cody's network", trade: "Siding", contractTotal: 18573.20, grossMarginPct: 0.1377, grossProfit: 2557.53, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 18573.20 * 0.13, netProfit: 0 },
  { jobInfo: "S-3679: Elise Hanson", leadSource: "Site Survey Website", trade: "Solar", contractTotal: 26752.00, grossMarginPct: 0.3000, grossProfit: 8025.60, commissionPercentage: 0, salesCommission: 0, salesManagerFee: 0, companyOH: 26752.00 * 0.13, netProfit: 0 }
];

// Apply Cody Cline calculation formula
// Net Profit = Gross Profit - Company OH
// Sales Commission = Net Profit ÷ 2 (50% of Net Profit)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - job.companyOH;
  job.salesCommission = job.netProfit / 2;
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap);

export const codySalesJune2026Data: ReportData = {
  kpis: {
    adSpend: 0,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: 0,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit,
    netProfitPercent: totalNetProfit / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: [
    { source: "Referral- Cody's network", spend: 0 },
    { source: "Referral- Dominic's network", spend: 0 },
    { source: "Site Survey Website", spend: 0 }
  ],

  salesBySource: salesBySource,

  salesByTrade: salesByTrade,

  jobData: jobData,

  period: {
    month: 6,
    year: 2026
  }
};
